import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Notifications from 'react-notify-toast';
import WaitingModal from '../../generics/WaitingModal';
import ModalConfirmUnits from './ModalConfirmUnits';
import moment from 'moment';
import swal from 'sweetalert';
import { Table, FormGroup } from 'react-bootstrap';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Inputmask from 'inputmask';
import RaisedButton from 'material-ui/RaisedButton';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import { healthFacilities, lookups, lookupsType, unitAsociation, unitAsociationGetComponents, unitAsociationId, unitRequest, unitRequestConfirm } from '../../../libs/services';

var Config = require('../../../config');

class CinfirmOrderUnits extends Component{
	constructor(props){
		super(props);

		this.validateInput = this.validateInput.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onSearchComponent = this.onSearchComponent.bind(this);
		this.addComponent = this.addComponent.bind(this);
		this.removeUnitFromList = this.removeUnitFromList.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.validateConfirmation = this.validateConfirmation.bind(this);

		this.state = {
			date_form : "",
			hour: "",
			health_facilities:[],
			requested_by:"",
			requested_to:"",
			messenger:"",
			user:"",
			user_id:"",
			priority:"",
			observations:"",
			priorities:[{id:"0",name:"URGENTE"},{id:"0",name:"24 HORAS"}],
			status:"",

			requestedSelected:[],
			indice:-1,

			requested2Selected:[],
			indice2:-1,

			bloodComponents:[],
			groupRH:[],

			blood_component:"",
			amount:"",
			group_rh:"",

			unitsAdded:[],

			isLoading: false,
			req_by:null,
			req_to:null,

			units_send:[],
			units_send_aux:[],
			component:{},
		}
	}

	async componentDidMount(){

		if (this.props.match.params.id !== -1) {
			//editar
			var response = await unitRequest(this.props.match.params.id);
			if(response !== undefined){
				var date = new Date(response.date);

				var sol_us = response.medical_staff;

				//Usuario que envió
				var env_us = response.user_send;
					
				this.setState({
					requested_by:response.distribuidor,
					requested_to:response.receptor_name,
			      	observations: response.observations,
			      	hour:response.hour,
			      	priority:response.priority,
			      	status:response.status,
			      	messenger:response.mensajero,
			      	user:sol_us,
			      	user_send:env_us,
			      	date_form : date.getFullYear()+'-'+("0" + (date.getMonth() + 1)).slice(-2)+'-'+("0" + date.getDate()).slice(-2),
			    });

				for (var i = 0; i < response.detail.length; i++) {
			    	var obj = {}
					obj.component_type = response.detail[i].component_type;
					obj.component_name = response.detail[i].component;
					obj.amount = response.detail[i].amount;
					obj.group_rh = response.detail[i].group +''+ 
									(response.detail[i].rh === 'POSITIVO' ? '+' :
									response.detail[i].rh === 'NEGATIVO' ? '-' : response.detail[i].rh);
					obj.group = response.detail[i].group;
					obj.rh = response.detail[i].rh;
					obj.confirm_amount = 0;
					obj.amount_received = 0;		
					
					this.setState({ unitsAdded: [...this.state.unitsAdded, obj]});				
			    };

			    response.units.some((unit)=>{
					var aux_group_rh = unit.unit.group + (unit.unit.rh === 'POSITIVO' ? '+' : unit.unit.rh === 'NEGATIVO' ? '-' : unit.unit.rh);
					var index = this.state.unitsAdded.findIndex(obj => 
			    		(obj.component_type === unit.component_type && obj.group_rh === aux_group_rh)
			    	
			    	)

			    	if(index === -1){
			    		var obj = {}
						obj.component_type = unit.component_type;
						obj.component_name = unit.component;
						obj.amount = 0;
						obj.group_rh = unit.unit.group +''+ (unit.unit.rh === 'POSITIVO' ? '+' : unit.unit.rh === 'NEGATIVO' ? '-' : '');
						obj.group = unit.unit.group;
						obj.rh = unit.unit.rh === 'POSITIVO' ? '+' : unit.unit.rh === 'NEGATIVO' ? '-' : unit.unit.rh;
						obj.confirm_amount = 0;
						obj.amount_received = 1;		
						
						this.setState({ unitsAdded: [...this.state.unitsAdded, obj]});
			    	}else{
						this.state.unitsAdded[index].amount_received++;
					}
			    })
				this.confirmUnits(this.props.match.params.id);
			    this.getHealthFacilities();
			}			
		}

		var selector = document.getElementById("hour");
		var im = new Inputmask("--:--");
		im.mask(selector);

		//obtener usuario
		var user = JSON.parse(sessionStorage.getItem('medical_staff'));

		var name = ""
		if (user.names) {name += user.names};
		if (user.lastname1) {name += ' '+user.lastname1};
		if (user.lastname2) {name += ' '+user.lastname2};

		this.setState({
			user_send:  name,
			user_id:user.id
		});		

		//componentes sanguineos

		response = await lookups('blood_component_type', 'true');
		if(response !== undefined){
			this.setState({
				bloodComponents: response
			});
		}

		//grupo y rh
		response = await lookupsType('blood_group_rh');
		if(response !== undefined){
			this.setState({
				groupRH: response
			});
		}
	}

	//get units asociation
	async getUnits(id){
		var response = await unitAsociation(id);
		if(response !== undefined){
			/*this.setState({
		      bloodComponents: response
		    });*/
				/*for (var i = 0; i < response.unit_request_details.length; i++) {
			    	var obj = {}
					obj.component_type = response.unit_request_details[i].component_type;
					obj.amount = response.unit_request_details[i].amount;
					obj.group_rh = response.unit_request_details[i].group_value +' '+ response.unit_request_details[i].rh_value;
					obj.group = response.unit_request_details[i].group;
					obj.rh = response.unit_request_details[i].rh;
					obj.confirm_amount;
					
					
					this.setState({ unitsAdded: [...this.state.unitsAdded, obj]});
			    	
			    };*/
		}
	}

	//get healt facilities
	async getHealthFacilities(){
		//traer hospitales
		var response = await healthFacilities();
		if(response !== undefined){
			this.setState({
				health_facilities: response
			});
			  
			for (var i = 0; i < response.length; i++) {
				
				if (response[i].name == this.state.requested_by) {
					
					this.setState({
						indice:i,
						requestedSelected: [response[i]],
					});
					
				};

				if (response[i].name == this.state.requested_to) {
				
					this.setState({
						indice2:i,
						requested2Selected: [response[i]],
					});
					
				};
			};
		}
	} 

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		var campo = e.target.name;

		this.setState({
			[campo] : e.target.value
		});

		if(campo === 'hour'){
			var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		
		}else{
			if(e.target.value !== ""){
				setTimeout(function(){
					this.showCtrlError(campo);
				}.bind(this), 500)
			}
				
		}	
	}

	handleChangeTable(type, group_rh){
		
		var index = this.state.unitsAdded.findIndex(obj => 
			(obj.component_type === type && obj.group_rh === group_rh)
		);

		if(index !== -1){
			this.state.unitsAdded[index].confirm_amount += 1;
			this.forceUpdate();
		}
			
	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	if(name === 'component'){
        		if(values[0].status !== 'BLOQUEADA'){
        			this.setState({
			            [name]: values[0]
			        });

			        setTimeout(()=>{
			        	this.addComponent();
			        }, 500)
        		}else{
        			swal('Error', 'El componente que intenta seleccionar se encuentra bloqueado', 'error');
					this._typeahead_component.getInstance().blur();
					this._typeahead_component.getInstance().clear();
					this._typeahead_component.getInstance().focus();
        		}
	        		
        	}else{
        		this.setState({
		            [name]: values[0].id
		        });

		        if (name === 'requested_by') {
		        	this.setState({
						indice:0,
						requestedSelected:values,
				    });
		        };

		        if (name === 'requested_to') {
		        	this.setState({
						indice2:0,
						requested2Selected:values,
				    });
		        };
        	}
        	
        }
    }

    _handleSearch = (query) => {
	    this.setState({
			indice:-1,
			requestedSelected:[],
	    });
	}

	_handleSearch2 = (query) => {
	    this.setState({
			indice2:-1,
			requested2Selected:[],
	    });
	}

	onSearchComponent(e){
		if(e.length > 0){
			console.log(e)
		}
	}

	addComponent(){
		var flag = true;
		var repeated = false;

		if (this.state.component.unit_id ) {
			var temp = this.state.units_send;
			for (var i = 0; i < temp.length; i++) {


				if (parseInt(temp[i].unit.id) === parseInt(this.state.component.unit_id) ) {
					
					var index = this.state.units_send_aux.findIndex(obj => 
						(obj.units_asociation.id === temp[i].units_asociation.id &&
						obj.unit.component_number === temp[i].unit.component_number)
					);

					if(index === -1){
						flag = false;
						this.handleChangeTable(temp[i].blood_component.component_type, temp[i].group+''+temp[i].rh)
						this.setState({
							units_send_aux: [...this.state.units_send_aux, temp[i]],
							component:{}
						})
						break
					}else{
						flag = false;
						repeated = true;
					}	
				};
					
			};

			this.setState({
				unit_number:"",
				component_list:[]
			});
			this._typeahead_component.getInstance().clear();

			if (flag === true) {
				swal('¡La unidad no se puede agregar!', '¡No se encontro!', 'error');
			}else if(repeated){
				swal('¡La unidad no se puede agregar!', '¡La unidad ya fue confirmada!', 'error');
			} 
		} else{
			swal('¡El registro no se puede agregar!', '¡Ingrese componente!', 'error');
		};
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined)
    			form.elements[index + 1].focus();
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	isValidSearch(){
	    let isFormValid = true;
	    const unit_number = document.getElementById('unit_number');

    	const isInputValid2 = this.showCtrlError(unit_number.name);
      	if (!isInputValid2) {
        	isFormValid = false;
    	}

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	removeUnitFromList = (indice) => {
		
		var array = [...this.state.unitsAdded];
		array.splice(indice, 1);
		this.setState({unitsAdded: array});
	}

	async onSave(status){
		var units = [];
		this.state.units_send_aux.map((u)=>{
			var element = document.getElementById('check_'+u.units_asociation.unit_request_id).checked;
			if(element){
				units.push(u.units_asociation.id);
			}
		});

		var response = await unitRequestConfirm(sessionStorage.getItem("health_facilities_id"), status, units, this.props.waiting);
		// var response = await unitRequestConfirm(sessionStorage.getItem("health_facilities_id"), units, status);
		if(response !== undefined){
			swal({
				  title: "Proceso Terminado",
				  html:true,
				  text: 'Unidades confirmadas',
				  type: 'success',
			}, function (isConfirm) {
				if (isConfirm) {
					 this.props.history.push('/distribution');
				}else{
					  return false;
				}
			}.bind(this));
			
		}
	}

	validateConfirmation(type){
		var confirm = 0;
		if(type === 'confirmar'){
			this.state.unitsAdded.some((unit)=>{
				if(unit.amount_received - unit.confirm_amount > 0){
					confirm++;
				}
			});
			if(confirm > 0){
				swal({
					title: '¿Está seguro?',
					text: 'Quedan unidades pendientes de confirmación',
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#DD6B55',
					confirmButtonText: '¡Continuar!',
					cancelButtonText: '¡Cancelar!',
					closeOnConfirm: true,
					closeOnCancel: true
				},  (isConfirm)=> {
					if (isConfirm) {
						this.onSave('SURTIDO INCOMPLETO');
					}
				});
			}else{
				this.onSave('RECIBIDA');
			}
			
		}else{
			this.onSave('SUMINISTRADO');

		//return confirm;
		}
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		if(input.id === 'requested_by' || input.id === 'requested_to'){
	    			isFormValid = this.getValidationState(input.id);
	    		}else{
	    			const isInputValid = this.showCtrlError(input.name);
			      	if (!isInputValid) {
			        	isFormValid = false;
			    	}
	    		}
	    		
			      			   
		  	}
	    });
	    
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	getValidationState(name) {
		const length = this.state[name].length;
		let isFormValid = true;
		if (length === 0){
			if(name==='requested_by'){
				this.setState({req_by:'error'});
				isFormValid = false;
			}else{
				this.setState({req_to:'error'});
				isFormValid = false;
			}
		}else{
			if(name==='requested_by'){
				this.setState({req_by:''});
			}else{
				this.setState({req_to:''});
			}
		}

		return isFormValid;
	}

	async confirmUnits(id){
		var response = await unitAsociationId(id, this.props.waiting);
		if(response !== undefined){
			response.forEach((res, i)=>{
				var res_group_rh = res.group+res.rh;
				this.state.unitsAdded.some((unit, j)=>{
					if(res.units_asociation.component_type === unit.component_type && res_group_rh === unit.group_rh){
						//unit.amount_received += 1;
						if(res.units_asociation.received !== null){
							this.handleChangeTable(res.units_asociation.component_type, unit.group_rh);
							
							this.setState({
								units_send_aux: [...this.state.units_send_aux, res]
							});
						}
					}
					
				});
			});

			this.forceUpdate();

			this.setState({ 
				units_send: response,
			});
		}
	}

	onCancel(){
		this.props.history.push("/distribution");
	}

	async searchComponent(e){
		if(e.key === 'Enter'){
			e.preventDefault();

			var response = await unitAsociationGetComponents(e.target.value, sessionStorage.getItem('health_facilities_id'), this.props.match.params.id);
			if(response !== undefined){
				this.setState({
					component_list: response
				})
				this._typeahead_component.getInstance().clear();
				this._typeahead_component.getInstance().focus();
			}else{
				document.getElementById('unit_number').focus();
			}
		}
	}

	render(){
		const {t} = this.props;

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.distribution.MAIN')} ->
						Confirmación de Unidades
					</h5>
				</div>
				<form noValidate>
					<div className="col-xs-12">
						<div className="col-xs-12">
							<div className="col-xs-12 col-sm-3">
								<FormGroup id="req_by" validationState={this.state.req_by} style={{marginBottom:"0px"}}>
									<span className="span-min">Centro Distribuidor</span>
									
									<AsyncTypeahead
							          	/*{...this.state}*/
							          	labelKey={(option) => `${option.name}`}
							          	minLength={0}
							          	inputProps={{
							          		name:"requested_by",
							          		required:true,
							          		id:"requested_by"
							          	}}
							          	id="requested_b"
							          	disabled={true}
							          	options={this.state.health_facilities}
							          	onChange={this.handleTypeAheadChange('requested_by')}
							          	onSearch={this._handleSearch}
							          	defaultSelected={this.state.health_facilities.slice(this.state.indice, 1)}
							          	selected={this.state.requestedSelected}
							          	ref={ref => this._typeahead = ref}
							          	useCache={false}
							          	isLoading={this.state.isLoading}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
							    </FormGroup>
							</div>

							<div className="col-xs-12 col-sm-3">
								<FormGroup id="req_to" validationState={this.state.req_to} style={{marginBottom:"0px"}}>
									<span className="span-min">Centro Peticionario</span>
									<AsyncTypeahead
							          	/*{...this.state}*/
							          	labelKey={(option) => `${option.name}`}
							          	minLength={0}
							          	inputProps={{
							          		name:"requested_to",
							          		required: true,
							          		id:"requested_to"
							          	}}
							          	id="requested_t"
							          	disabled={true}
							          	options={this.state.health_facilities}
							          	onChange={this.handleTypeAheadChange('requested_to')}
							            onSearch={this._handleSearch2}
							          	defaultSelected={this.state.health_facilities.slice(this.state.indice2, 1)}
							          	selected={this.state.requested2Selected}
							          	ref={ref => this._typeahead = ref}
							          	useCache={false}
							          	isLoading={this.state.isLoading}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
							    </FormGroup>
							</div>

							<div className="col-xs-12 col-sm-3">
								<div className="col-xs-12 col-sm-6">
									<span className="span-min">Fecha Petición</span>
									<input className="form-control"  disabled name="date_form" id="date_form" type="date" value={this.state.date_form || ""} 
											onChange={this.handleChange} ref={(input) => { this.inputRef = input }} onKeyPress={(e) => this.validateInput(e)} required />
								</div>
								<div className="col-xs-12 col-sm-6">
									<span className="span-min">Hora Petición</span>
									<input id="hour"  disabled name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
											data-inputmask-placeholder="-" value={this.state.hour || ""} onChange={this.handleChange}
											required onKeyPress={(e)=>this.validateInput(e)} className="form-control"/>
								</div>
							</div>

							<div className="col-xs-12 col-sm-3">
								<span className="span-min">Prioridad</span>
								<select className="form-control" name="priority" id="priority" required
									onChange={this.handleChange}  disabled value={this.state.priority || ""} onKeyPress={(e) => this.validateInput(e)}>
									<option value="">Seleccione...</option>
									{this.state.priorities.map((type, i) => (
										<option key={i} value={type.name}>{type.name}</option>
									))

									}
								</select>
							</div>
						</div>	

						<div className="col-xs-12">
							<div className="col-xs-12 col-sm-3">
								<span className="span-min">Usuario Solicita</span>
								<input className="form-control" disabled name="user" id="user" value={ this.state.user } onChange={ this.handleChange } required/>
							</div>

							<div className="col-xs-12 col-sm-3">
								<span className="span-min">Usuario Envió</span>
								<input className="form-control" disabled name="user_send" id="user_send" value={ this.state.user_send || "" } onChange={ this.handleChange } required/>
							</div>

							<div className="col-xs-12 col-sm-3" style={{padding:"0 15px"}}>
								<span className="span-min">Mensajero</span>
								<input className="form-control" disabled name="messenger" id="messenger" value={ this.state.messenger || "" } onChange={ this.handleChange } required/>
							</div>
						</div>

						<div className="col-xs-12 form-group">
							<div className="col-xs-12">
								<span className="span-min">Observaciones</span>
								<textarea className="form-control"  disabled name="observations" value={ this.state.observations || ""} onChange={ this.handleChange } />
							</div>
						</div>

						<fieldset className="col-xs-12">
							<legend style={{fontSize:"1.5em"}}>Control de Unidades</legend>

							<div className="col-xs-12 col-sm-9"> 
				              <Table responsive hover style={{margin:"0px"}}>
				                <thead>
				                  <tr>
				                    <th>Componente Sanguineo</th>
				                    <th>Unidades Solicitada</th>
				                    <th>Unidades Suministradas</th>
				                    <th>Unidades Recibidas</th>
				                  </tr>
				                </thead>
				                <tbody>
				                 	{this.state.unitsAdded.map( (unit, index) => (
					                    <tr key={index}>
					                      	<td>{unit.component_name}</td>
					                      	<td>{unit.amount > 0 ? unit.amount + ' ('+unit.group_rh+')' : unit.amount}</td>
					                      	<td>{unit.amount_received > 0 ? unit.amount_received + ' ('+unit.group_rh+')' : unit.amount_received}</td>
					                 		<td>{unit.confirm_amount > 0 ? unit.confirm_amount + ' ('+unit.group_rh+')' : unit.confirm_amount}</td>
					                    </tr>
				                    ))}
				                </tbody>
				              </Table>
				            </div>
						</fieldset> 

						<fieldset className="col-xs-12">
							<legend style={{fontSize:"1.5em"}}>Confirmar Unidades Recibidas</legend>
							
							<div className="col-xs-12 form-group">
								<div className="col-xs-12 col-sm-3" style={{padding:"0 10px 0 0"}}>
									<span className="span-min">No. Unidad</span>
									<input type="text" name="unit_number" id="unit_number"  
											onChange={this.handleChange} value={this.state.unit_number || ""} 
											onKeyPress={(e) => this.searchComponent(e)}
											className={"form-control"} />
								</div>

								<div className="col-xs-12 col-sm-3" style={{padding:"0 7px 0 4px"}}>
									<span className="span-min">No. Componente</span>
									<AsyncTypeahead
							          	/*{...this.state}*/
							          	labelKey={(option) => `${option.label}`}
							          	minLength={0}
							          	inputProps={{
							          		name:"component",
							          		id:"component"
							          	}}
							          	id="component_text"
							          	options={this.state.component_list}
							          	onChange={this.handleTypeAheadChange('component')}
							          	onSearch={this._handleSearch}
							          	ref={ref => this._typeahead_component = ref}
							          	useCache={false}
							          	isLoading={this.state.isLoading}
							          	selectHintOnEnter={true}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
								</div>

								<div className="col-xs-12 col-sm-1">
									<FloatingActionButton className="action-btn" mini={true} 
										style={{marginTop: 18 }} id="add_button" 
										onClick={this.addComponent} iconStyle={{height: 25, width: 25}}>
				                      <ContentAdd/>
				                    </FloatingActionButton> 
								</div>
							</div>

							<div className="col-xs-12"> 
				              <Table responsive hover style={{margin:"0px"}}>
				                <thead>
				                  <tr>
				                    <th>No. Unidad</th>
				                    <th>Componente</th>
									<th>Grupo & RH</th>
				                    <th>No. Componente</th>
				                    <th></th>
				                  </tr>
				                </thead>
				                <tbody>
				                 {this.state.units_send_aux.map( (unit, index) => (
				                    <tr key={index}>
				                      <td>
				                      	{unit.unit.unit_number}
				                      </td>
				                      <td>
				                      	{unit.blood_component.component}
				                      </td>
									  <td>{unit.group+unit.rh}</td>
				                      <td>{unit.unit.component_number}</td>
				                      <td>
				                      	<input disabled type="checkbox" id={"check_"+unit.units_asociation.unit_request_id} checked="true" />
				                      </td>
				                    </tr>
				                    ))}
				                </tbody>
				              </Table>
				            </div>
						</fieldset> 

				        <hr style={{width:"100%"}}/>
						<div className="col-xs-12" style={{textAlign:'center'}}>
				        	<div>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.confirm')} primary={true} onClick={this.validateConfirmation.bind(this, 'confirmar')}  style={{margin:12}}/>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.validateConfirmation.bind(this, 'guardar')}  style={{margin:12}}/>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onCancel}/>
				        	</div>
				        </div>
											
					</div>


				</form>

				<Notifications />
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				<ModalConfirmUnits {...this.props} onRef={ref => (this.modal_view_information = ref)} refresh={this.props.refresh} />
			</div>
		)
	}
}

export default translate('translations')(CinfirmOrderUnits);
